/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import SectionNav from "components/section-nav";
import NavTabs from "components/section-nav/tabs";
import NavItem from "components/section-nav/item";
import { Box } from "@towersystems/towersystems-design-system";

const Navigation = (props) => {
  return (
    <Box>
      <SectionNav>
        <NavTabs>
          <NavItem path={"/me"} selected={props.section === "profile"}>
            Profile
          </NavItem>
          <NavItem
            path={"/me/preferences"}
            selected={props.section === "preferences"}
          >
            Preferences
          </NavItem>
        </NavTabs>
      </SectionNav>
    </Box>
  );
};

export default Navigation;
